import { Card, GradientShadow } from "@/components";

export const About = () => (
  <div id="about" className="text-center section relative z-10 ">
    <div className="first-letter:capitalize text-2xl md:text-3xl lg:text-5xl capitalize">
      about me
    </div>
    <div className="flex justify-center">
      <div className="mt-4 w-11/12 md:w-10/12 lg:w-2/3 md:mt-7 text-sm md:text-lg xl:text-xl first-letter:capitalize">
        A creative fullstack developer based in Tehran, known for a distinctive
        work ethic and a passion for crafting elegant, high-performance digital
        experiences.
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-7 mt-12 md:mt-14">
      <Card className="p-6 lg:p-10">
        <div className="first-letter:capitalize text-lg md:text-xl lg:text-2xl">
          high standards
        </div>
        <div className="flex justify-center">
          <div className="desc">
            creating an efficient process for usability and receiving info by
            users on the apps and websites they use daily.
          </div>
        </div>
        {/* <GradientShadow type="tl" /> */}
      </Card>
      <Card className="p-6 lg:p-10">
        <div className="first-letter:capitalize text-lg md:text-xl lg:text-2xl">
          main goal
        </div>
        <div className="flex justify-center">
          <div className="desc">
            turning unique ideas into reality through software that’s efficient,
            purposeful, and built to stand out.
          </div>
        </div>
        {/* <GradientShadow type="tr" color="blue" /> */}
        {/* <GradientShadow type="bl" /> */}
      </Card>
      <Card className="p-6 lg:p-10">
        <div className="first-letter:capitalize text-lg md:text-xl lg:text-2xl">
          outstanding results
        </div>
        <div className="flex justify-center">
          <div className="desc">
            creative software development of any complexity, with the best
            optimization and data processing speed.
          </div>
        </div>
        {/* <GradientShadow type="tr" /> */}
      </Card>
    </div>
  </div>
);
